// src/utils/helpers.js
export const stripHtmlTags = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

export const highlightTagInText = (text = "", tag = "") => {
  if (!tag) return text;

  const escapedTag = tag.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // escape regex
  const regex = new RegExp(`\\b(${escapedTag})\\b`, "gi");

  const parts = text.split(regex);
  return parts.map((part, index) =>
    part.toLowerCase() === tag.toLowerCase() ? (
      <span
        key={index}
        style={{
          backgroundColor: "#f8d7da",
          padding: "0 4px",
          borderRadius: "4px",
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};
